<pdq-card variant="popover" color="white">
  <div class="card-title">
    <pdq-heading element="h5">Display conditions</pdq-heading>
  </div>
  <pdq-divider></pdq-divider>
  <div class="card-content">
    <p class="body-14-regular">This Checkout Content Will Only Appear If:</p>
    <checkout-content-restrictions
      [formGroup]="formGroup"
      [shopCurrencySymbol]="shopCurrencySymbol"></checkout-content-restrictions>
  </div>
</pdq-card>
